import React, {useState, useContext, useRef, useEffect} from "react";

import {View, Text, BackHandler}  from 'react-native'

import contexto from '../util/contexto'

import {estilos} from '../util/estilos'

import {useNavigation} from '@react-navigation/native'

import * as util from '../util/util'

import { useFocusEffect } from '@react-navigation/native';

import { ViewDegradeVertical} from '../componentes/ViewDegradeVertical';

import Botao from '../componentes/Botao'

import {carregamento} from '../componentes/Carregamento'

import {semDados} from '../componentes/SemDados'

import * as validacao from '../util/validacao'

import FormularioEndereco from '../componentes/FormularioEndereco'

import {novoEndereco, excluirEndereco, buscarEnderecos} from '../ws/ws_enderecos'

import cores from '../util/cores'

import {TELA_PRINCIPAL, MSG_ERRO_PADRAO} from '../util/constantes'

import Alerta from '../componentes/Alerta'

import Bloco from '../componentes/Bloco'

import Scroll from '../componentes/Scroll'




export default function TelaMeusEnderecos(){

	const {valorContexto, setValorContexto} = useContext(contexto);

	const navegacao = new useNavigation();

	const [sincronizando, setSincronizando] = useState(true)  
   
	const [lista, setLista] = useState([])
	
	const [novo, setNovo] = useState(false)  
	
	const [carregado, setCarregado] = useState(false) 
	
	const formularioEnderecoRef  = useRef(null);
	
	const [idRemover, setIdRemover] = useState()   

	const blockBackRef = useRef(false);
	
	

	const voltar = () => {

		if(blockBackRef.current == true){
							
			setNovo(false)
					
			blockBackRef.current = false;
		}
		else
			navegacao.replace(util.processaVoltar())

		return true;
	};


	useFocusEffect(React.useCallback(() => {

		util.print("TelaMeusEnderecos");
		
		BackHandler.addEventListener('hardwareBackPress', voltar);
		
		buscarDados();
		
		return () => {
			BackHandler.removeEventListener('hardwareBackPress', voltar);
		};	
	}, []));
	
	
	const prepararFormulario= async ()=>{
	
		console.log("prepararFormulario "+carregado+" "+novo);
	
		if(carregado== true && novo==true && formularioEnderecoRef.current!=null)	{

			console.log("setDados");
			
			formularioEnderecoRef.current.setDados(valorContexto.idUsuarioAtual, null);
		}
		
	}
	
	
	useEffect(() => {prepararFormulario()}, [sincronizando, novo]);
	
	
	const buscarDados= async ()=>{

		setSincronizando(true)

		setNovo(false)

		blockBackRef.current = false;

		let itens  = await buscarEnderecos(valorContexto.idUsuarioAtual);
   
		setLista(util.temConteudo(itens)?itens:[]);
				
		setCarregado(true);
		
		setSincronizando(false)
	}
	

	async function salvar(dados){
		
		dados['id_usuario'] = valorContexto.idUsuarioAtual;
		
		let retorno = await novoEndereco(dados);
	
        if( retorno==null || retorno.id==null){
                
            formularioEnderecoRef.current.salvarErro(MSG_ERRO_PADRAO);
            return;
        }

        formularioEnderecoRef.current.salvarSucesso();
		
		buscarDados();
    }


	const preparaParaRemover= (id)=>{

		console.log("preparaParaRemover "+id);
		
		Alerta("Exclusão de Endereço", "Deseja realmente excluir este endereço?", async () => excluir(id));
	}


	const excluir= async (id)=>{
		
		console.log("excluindo "+id);
		
		setSincronizando(true);
		
		await excluirEndereco(id);
		
		buscarDados();
    }


	return (
		<ViewDegradeVertical titulo="Meus Endereços" voltar={()=>voltar()}>  
			{ (sincronizando) ?
				(carregamento(sincronizando)):
				(novo?
					<Scroll> 
						<FormularioEndereco ref={formularioEnderecoRef} salvar={salvar}/>
					</Scroll>:
					(<View style={{flex:1}}> 
						<View style={{alignItems:'flex-end'}}>
							<Botao 
								acao={()=>{
									
									blockBackRef.current = true;

									setNovo(true)
								}}
								texto="Novo Endereço"/>   
						</View>
						{util.temConteudo(lista)?
							<Scroll> 
								{lista.map((item, index) =>itemLista(item, index))}
							</Scroll>:
							(<Bloco todaArea={true}> 
								{semDados("info", "Nenhum endereço cadastrado", 60)}
								<View style={{marginTop:10}}/>	
							</Bloco>)
						}
					</View>)
				)				
			}
		</ViewDegradeVertical>
	); 


	function itemLista(item, index){

		return (
			<Bloco key={index}> 
				<View style={{marginTop:5}}/>
				
				<View style={estilos.grade}>
					<View style={[estilos.coluna, {alignItems:'flex-start'}]}> 
						<Text style={estilos.rotulo_padrao}>CEP: {validacao.formataCep(item.cep)}</Text>
					</View>
					<View style={[estilos.coluna, {alignItems:'flex-end'}]}> 
						<Text style={estilos.rotulo_padrao}>{util.getDescricaoTipoEndereco(item.tipo)}</Text>
					</View>
				</View>
				<Text style={estilos.rotulo_titulo}>{item.logradouro}, {item.numero}</Text>
				<Text style={estilos.rotulo_padrao}>{item.bairro} {item.cidade_nome} {item.uf}</Text>
				
				<View style={{marginTop:5}}/>

				<View style={{alignItems:'flex-end'}}> 
                    <Botao
                        acao={()=>preparaParaRemover(item.id)}
                        texto="Remover"
						cor={cores.vermelho}/>    
				</View>
				<View style={{marginTop:5}}/>
			</Bloco>	
		)
	}
}